import { Link } from "react-router-dom";
import styles from "../../pages/BlogArticle.module.scss";
import { CLOUDINARY_BASE_URL } from "../../config/cloudinary";
import { categories, tagLinks, sidebarTourCard } from "./articleConstants";
import { trackCtaClick, trackEvent } from "../../utils/analytics";
import { useLanguage } from "../../contexts/LanguageContext";
import {
  getLocalizedValue,
  localizeCategoryItems,
  localizeTagItems,
} from "../../utils/localizedContent";
import { blogText } from "../../i18n/blog";

const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;

export function Sidebar({ popularArticles }) {
  const { lang } = useLanguage();
  const t = blogText[lang] || blogText.JP;
  const localizedCategories = localizeCategoryItems(categories, lang);
  const localizedTagLinks = localizeTagItems(tagLinks, lang);
  const localizedTourCard = {
    ...sidebarTourCard,
    title: getLocalizedValue(sidebarTourCard.title, lang),
    text: getLocalizedValue(sidebarTourCard.text, lang),
    buttonText: getLocalizedValue(sidebarTourCard.buttonText, lang),
  };

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sideBox}>
        <p className={styles.sideLabel}>{t.categoryLabel}</p>
        <h2>{t.sideCategoryTitle}</h2>

        <div className={styles.sideCategoryList}>
          {localizedCategories.map((category) => (
            <Link
              key={category.key}
              to={category.path}
              onClick={() =>
                trackEvent("blog_category_click", {
                  event_category: "blog",
                  event_label: category.key,
                  category_key: category.key,
                  destination: category.path,
                  placement: "blog_sidebar",
                })
              }
            >
              <span>{category.icon}</span>
              <strong>{category.label}</strong>
            </Link>
          ))}
        </div>
      </div>

      {popularArticles.length > 0 && (
        <div className={styles.sideBox}>
          <p className={styles.sideLabel}>{t.popularSideLabel}</p>
          <h2>{t.popularArticles}</h2>

          <div className={styles.popularList}>
            {popularArticles.map((item) => (
              <Link
                key={item.slug}
                to={`/blog/${item.slug}`}
                className={styles.popularItem}
                onClick={() =>
                  trackEvent("blog_popular_article_click", {
                    event_category: "blog",
                    event_label: item.slug,
                    article_slug: item.slug,
                    destination: `/blog/${item.slug}`,
                    placement: "blog_sidebar",
                  })
                }
              >
                <img src={item.mainImage} alt={item.title} />

                <div>
                  <strong>{item.title}</strong>
                  <span>{item.date}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className={styles.sideBox}>
        <p className={styles.sideLabel}>{t.tagLabel}</p>
        <h2>{t.sideTagTitle}</h2>

        <div className={styles.tagCloud}>
          {localizedTagLinks.map((tag) => (
            <Link
              key={tag.key}
              to={tag.path}
              onClick={() =>
                trackEvent("blog_tag_click", {
                  event_category: "blog",
                  event_label: tag.key,
                  tag_key: tag.key,
                  destination: tag.path,
                  placement: "blog_sidebar",
                })
              }
            >
              {tag.label}
            </Link>
          ))}
        </div>
      </div>

      <div className={styles.tourCard}>
        <img src={img(localizedTourCard.image)} alt={t.tourImageAlt} />

        <div>
          <h2>{localizedTourCard.title}</h2>
          <p>{localizedTourCard.text}</p>
          <Link
            to={localizedTourCard.path}
            onClick={() =>
              trackCtaClick({
                label: "blog_sidebar_tour_card",
                placement: "blog_sidebar",
                destination: localizedTourCard.path,
                destinationType: "internal_tour",
              })
            }
          >
            {localizedTourCard.buttonText}
          </Link>
        </div>
      </div>
    </aside>
  );
}
